import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BadgesAwardsService {
  requestBody: any;

  constructor(private http: HttpClient) { }

  getBadges() {
    const url = environment.apiURL + `api/creatics-badges/list`;
    return this.http.get(url);
  }

  getUserBadges(id:any){
    const url = environment.apiURL + `api/creatics-badges/user-list/${id}`
    return this.http.get(url);

  }

  getCreaticsCurrency(): Observable<any> {
    const url = environment.apiURL + 'api/creatics/login/home-page';
    return this.http.get(url);
  }

  getAllBadgesList(): Observable<any> {
    const url = environment.apiURL + 'api/all-badges/list';
    return this.http.get(url);
  }

  getCurrency(badgeId: any, amount: any, paymentType: any, productType: any, creaticsCurrency: any) {
    const url = environment.apiURL + `api/charge/products/${badgeId}`;
    const formData = new FormData();
    formData.append('amount', amount);
    formData.append('paymentType', paymentType);
    formData.append('productType', productType);
    formData.append('creaticsCurrency', creaticsCurrency);
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  getPaymentDetails(id: any) {
    const url = environment.apiURL + `api/charge/badge/transaction/${id}`;
    return this.http.get(url);
  }
  setRequestBody(body: any) {
    this.requestBody = body;
  }
  getRequestBody() {
    return this.requestBody;
  }
  getId() {
    return this.requestBody ? this.requestBody.id : null;
  }
  getName() {
    return this.requestBody ? this.requestBody.name : null;
  }

  getStripeDetails(id: any) {
    const url = environment.apiURL + `api/creatics-badges/list/${id}`;
    return this.http.get(url);
  }

  getBadgeDetails() {
    const url = environment.apiURL + `api/creatics-badges/list`;
    return this.http.get(url);
  }

  createPayment(stripeToken: any, amount: any, id: any): Observable<any> {
    const url = environment.apiURL + `api/creatics-badges/${id}/charge`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('stripeToken', stripeToken);
    params = params.set('amount', amount);
    return this.http.post(url, id, {
      params: params,
      responseType: 'text'
    });
  }

  //stripe token api
  getBadgeDetailsById(id: any) {
    const url = environment.apiURL + `api/creatics-badges/${id}`;
    return this.http.get(url);
  }

  getBadgesAdmin(formData: FormData) {
    const url = environment.apiURL + 'api/creatics-badges/create';
    const headers = new HttpHeaders();
    console.log('in service file', 'value', formData);
    return this.http.post(url, formData, { headers, responseType: 'text' });
  }

  deleteBadges(id: any): Observable<any> {
    const url = environment.apiURL + `api/creatics-badge/delete/` + id;
    return this.http.delete(url, {responseType: 'text'});
  }

  updateBadges(id: any, formData: any,params) {
    const url = environment.apiURL + `api/creatics-badge/update/`+ id;

    return this.http.patch(url, formData,  {params,responseType: 'text' });
}

}

